import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateProductVariant, type UpdateVariantPayload } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateVariant(productId: string, variantId: string) {
  const token = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: UpdateVariantPayload & { unit?: string }) => {
      if (!token) throw new Error("No token available")
      const { unit, ...rest } = payload as any
      const body: UpdateVariantPayload = {
        ...rest,
        ...(unit !== undefined ? { measureUnit: unit } : payload.measureUnit !== undefined ? { measureUnit: payload.measureUnit } : {}),
      }
      delete (body as any).unit
      return updateProductVariant(variantId, body, token)
    },
    onSuccess: () => {
      // Invalidate the specific product to refetch variants
      queryClient.invalidateQueries({ queryKey: ["product", productId] })
      // Invalidate the specific variant details
      queryClient.invalidateQueries({ queryKey: ["product-variant", variantId] })
    },
  })
}
